import axios from "axios";
import api from "@/data/services/api";

export class CertificateService {
  verify(certId) {
    return axios.get(`https://api.classroom.concinnitylimited.com/api/certificate/verify/${certId}`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          return response.data.data;
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }

  getCertificate(lessonSlug) {
    return api.get(`/certificate/quiz/${lessonSlug}`)
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        console.log('response == > ', response.data.data)
        console.log('response == > ', response)
        return response.data.data;
      } else {
        throw 'Error: Wrong Status';
      }
    });
  }
}